import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function TableBrowserHeaderFilters({ config, filterList, filterSelection, dispatch }) {
    const { t } = useTranslation(config.topic ? ['tableBrowser', config.topic] : 'tableBrowser');

    if (!config.filterFields) return null;

    const visibleFields = config.filterFields.filter(f => f.showInHeader);

    if (visibleFields.length === 0) return null;

    const getFieldValue = field => filterList.find(f => f.propertyName === field.propertyName)?.value ?? '';

    const handleChange = (field, selected) => {
        const newFilterList = filterList.filter(f => f.propertyName !== field.propertyName);

        if (selected !== '')
            newFilterList.push({ propertyName: field.propertyName, type: 'EQUAL', value: selected });

        dispatch({ type: `${config.key}/filter/setFilterList`, payload: newFilterList });
    };

    return (
        <>
            {visibleFields.map(field => {
                const value = getFieldValue(field);
                const items = field.propertyType === 'Long' ? filterSelection?.entityMap?.[field.propertyName] || [] : filterSelection?.enumMap?.[field.propertyName]?.items || [];

                const label = t(`${config.topic}:${field.propertyName}`);

                return (
                    <FormControl key={field.propertyName} variant='outlined' size='small' className='ml-8'>
                        <InputLabel>{label}</InputLabel>
                        <Select label={label} value={value} onChange={e => handleChange(field, e.target.value)} style={{ minWidth: 120 }} className='rounded-3xl'>
                            <MenuItem value=''>{t('All')}</MenuItem>
                            {items.map(i => (<MenuItem key={i.id ?? i.value} value={i.id ?? i.value}>{i.name ?? i.label}</MenuItem>))}
                        </Select>
                    </FormControl>
                );
            })}
        </>
    );
}
